<p-messages severity="warn" *ngIf="limitInvalid">
  <ng-template pTemplate>
    <p>
      {{ limitInvalidMessage }}
    </p>
  </ng-template>
</p-messages>

<!-- <p-messages severity="info" *ngIf="isConfirmedPrintBatch">
  <ng-template pTemplate>
    <p>Este lote já esta confirmado pelo distribuidor!</p>
  </ng-template>
</p-messages> -->

<div class="p-fluid grid formgrid pt-2 px-2 gap-2" *ngIf="!isDownload">
  <div class="col-auto" *ngFor="let item of deliveryWays; let i = index">
    <p-button label="Lote {{ i + 1 }}" severity="info" (click)="filterPrintBatch(i)" styleClass="mb-2 mr-2"></p-button>
  </div>

  <div class="col-auto">
    <p-button label="Novo lote" icon="pi pi-plus" size="small" severity="success"
      styleClass="mb-2 ml-2 custom-add-button p-button-success" (click)="newPrintBatch()"></p-button>
  </div>
</div>

<div class="flex justify-content-end px-2 mb-2" *ngIf="isConfirmedPrintBatch && !modoEdicaoConfirmado">
  <button pButton type="button" label="Editar distribuição" icon="fa-solid fa-pen-to-square"
    class="inline-flex p-button-warning" (click)="editarDistribuicao($event)"></button>
</div>

<p-messages severity="info" *ngIf="modoEdicaoConfirmado" styleClass="mx-2">
  <ng-template pTemplate>
    <span>Editando a distribuição — só podem ser distribuídas {{ estoqueDisponivelDistribuicao }} peças (estoque disponível).</span>
  </ng-template>
</p-messages>

<div class="flex justify-content-end px-2" *ngIf="canRemoveCurrentBatch">
  <button pButton type="button" label="Remover lote" icon="fa-solid fa-trash" class="inline-flex p-button-danger"
    (click)="removePrintBatch($event)"></button>
</div>

<div class="p-fluid grid formgrid pt-2" *ngIf="!isDownload">
  <div class="field col-12 md:col-4">
    <label for="print-batch-quantity" class="required">Quantidade produzida</label>
    <p-inputNumber inputId="print-batch-quantity" [(ngModel)]="currentInfo.quantity" (ngModelChange)="onUpdateParent()"
      [showButtons]="true" buttonLayout="horizontal" [allowEmpty]="false" [disabled]="isConfirmedPrintBatch" [min]="0"
      spinnerMode="horizontal" incrementButtonIcon="fa-solid fa-plus"
      decrementButtonIcon="fa-solid fa-minus"></p-inputNumber>
  </div>
  <div class="field col-12 md:col-4">
    <label for="print-batch-unit-price" class="required">Valor unitário</label>

    <input id="unitPrice" type="text" (ngModelChange)="onUpdateParent()" currencyMask [disabled]="isConfirmedPrintBatch"
      pInputText maxlength="150" [(ngModel)]="currentInfo.unitPrice"
      [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" />
  </div>
  <div class="field col-12 md:col-4" #printBatchExpectedOnArea>
    <label for="print-batch-expected-on" class="required">Data prevista de chegada</label>
    <p-calendar id="print-batch-expected-on" [(ngModel)]="currentInfo.expectedOn" (ngModelChange)="onUpdateParent()"
      [disabled]="isConfirmedPrintBatch" [showButtonBar]="true" [showIcon]="true" [minDate]="minDate"
      [readonlyInput]="false" dateFormat="dd/mm/yy"></p-calendar>
  </div>
</div>

<div class="field col-12 md:col-12">
  <label for="target" class="required">Forma de distribuição</label>
  <div *ngIf="itensDistrutionOptions.length > 0" class="flex flex-wrap gap-2 mt-3">
    <div *ngFor="let item of itensDistrutionOptions" class="field-checkbox">
      <div [pTooltip]="item.data">
        <input type="checkbox" [id]="'delivery-way-item-' + item.value" [name]="'delivery-way-' + item.value"
          [value]="item.value" [disabled]="isConfirmedPrintBatch && !modoEdicaoConfirmado" [checked]="deliveryWaysExists(item.value)"
          (change)="onChangeDeliveryWayItem($event, item)" />
        <label [for]="'delivery-way-item-' + item.value" class="cursor-pointer">{{
          item.label
          }}</label>
      </div>
    </div>
  </div>
</div>

<p-tabView>
  <p-tabPanel *ngIf="deliveryWaysExists('C')">
    <ng-template pTemplate="header">
      <div class="btn-custom" *ngIf="!isDownload">
        1. Estoque para grupos ({{ totalItensOnDistribution('C') }})
      </div>
      <div class="btn-custom" *ngIf="isDownload">1. Permissão para grupos</div>
    </ng-template>
    <distribution-group [deliveryWayByGroup]="listDeliveryWayByGroup" (changeTotal)="onChangeTotal($event)"
      (changed)="onGroupChange($event)" [totalValue]="totalItensOnDistribution('C')" [isConfirmed]="false"
      [isDownload]="isDownload"></distribution-group>
  </p-tabPanel>
  <p-tabPanel *ngIf="deliveryWaysExists('A')">
    <ng-template pTemplate="header">
      <div class="btn-custom">
        2. Distribuição automáticas ({{ totalItensOnDistribution('A') }})
      </div>
    </ng-template>
    <distribution-automatic [InputdeliveryWayAutomatic]="listDeliveryWayAutomatic" (changed)="onAutomaticChange($event)"
      (changeTotal)="onChangeTotal($event)" [totalValue]="totalItensOnDistribution('A')"
      [isConfirmed]="false"></distribution-automatic>
  </p-tabPanel>
  <p-tabPanel *ngIf="deliveryWaysExists('D')">
    <ng-template pTemplate="header">
      <div class="btn-custom">3. Distribuição direta ({{ totalItensOnDistribution('D') }})</div>
    </ng-template>
    <distribution-direct [InputdeliveryWayDirect]="listDeliveryWayDirect" (changed)="onDirectChange($event)"
      (changeTotal)="onChangeTotal($event)" [totalValue]="totalItensOnDistribution('D')"
      [isConfirmed]="false"></distribution-direct>
  </p-tabPanel>
  <p-tabPanel *ngIf="deliveryWaysExists('P')">
    <ng-template pTemplate="header">
      <div class="btn-custom" *ngIf="!isDownload">
        4. Estoque restrito ({{ totalItensOnDistribution('P') }})
      </div>
      <div class="btn-custom" *ngIf="isDownload">2. Restrito para prefixo</div>
    </ng-template>
    <distribution-restrict [InputdeliveryWayRestrict]="listDeliveryWayRestrict" (changed)="onRestrictChange($event)"
      (changeTotal)="onChangeTotal($event)" [totalValue]="totalItensOnDistribution('P')" [isConfirmed]="false"
      [isDownload]="isDownload"></distribution-restrict>
  </p-tabPanel>
</p-tabView>
